import React from 'react'
import { Avatar, HorizontalStack, ShowIf, Switch } from '@ztechapps/webui.util'
import isNil from 'lodash/isNil'
import { ChatAttachments } from '../Chat/ChatAttachments'
import { InternalNoteBadge, internalNoteClassName } from '../Chat/ChatMessages/InternalNoteBadge'
import { isInternalNoteMessage } from '../Chat/ChatMessages/isInternalNoteMessage'
import { MessageTimeStamp } from '../Chat/ChatMessages/MessageTimeStamp'
import styles from './MessageContent.module.scss'

//TODO: Set the type here properly
export const MessageContent = (props) => {
  const { from, timeStamp, content, attachments, isLeft, children, borderStyle = 'border-bottom' } = props
  // A note renders on a yellow card with its badge beside the author, so it cannot be read as a
  // customer-facing reply.
  const isInternalNote = isInternalNoteMessage(props)
  return (
    <HorizontalStack
      gap={2}
      className={`align-items-start ${isInternalNote ? internalNoteClassName : borderStyle} px-2 py-1 chat-message ${isLeft ? 'left' : 'right'}`}
    >
      <Avatar src={from?.profile?.picture} name={from?.profile?.name} size={30} />
      <div className={`flex-fill ${styles.flexFill}`}>
        <HorizontalStack className="justify-content-between mb-1">
          <div className=" text-primary fw-bold ">
            {from?.profile?.name}
            <ShowIf condition={isInternalNote}>
              <InternalNoteBadge />
            </ShowIf>
          </div>
          <MessageTimeStamp value={timeStamp} />
        </HorizontalStack>

        <Switch expression={!isNil(children)}>
          {{
            true: children,
            // A long unbroken token (a URL, an id) has no space for `white-space: normal` to
            // wrap on, so it runs past `.flex-fill`'s edge and overflows the card. `text-break`
            // (`overflow-wrap: anywhere` + `word-break: break-word`) breaks it mid-token instead.
            false: <span className="text-break">{content}</span>,
          }}
        </Switch>

        <ChatAttachments attachments={attachments} />
      </div>
    </HorizontalStack>
  )
}
